import { render, staticRenderFns } from "./UpdateChecker.vue?vue&type=template&id=2261a6f2&"
import script from "./UpdateChecker.vue?vue&type=script&lang=js&"
export * from "./UpdateChecker.vue?vue&type=script&lang=js&"
import style0 from "./UpdateChecker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports